export default {
  apiKey: "AIzaSyCv-R7cU7I3QxsJhTdzzmefey6tB9GwQ0I",
  authDomain: "lexcreativereuse-f1b81.firebaseapp.com",
  projectId: "lexcreativereuse-f1b81",
  storageBucket: "lexcreativereuse-f1b81.appspot.com",
  messagingSenderId: "370030010665",
  appId: "1:370030010665:web:fa741c424b3cdf0073d738"
};